// @flow

import AddressBlock from './AddressBlock'

export default AddressBlock
